import { Component, ViewChild } from '@angular/core';
import {
  NgbAccordionModule,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import Passenger from '../../../../../../core/data/models/passenger.model';
import { DatePipe } from '@angular/common';
import { dateFormats } from '../../../../../../common/constants/dateFormats';

@Component({
    selector: 'app-passanger-modal',
    imports: [NgbAccordionModule, DatePipe],
    templateUrl: './passanger-modal.component.html',
    styleUrl: './passanger-modal.component.css'
})
export class PassangerModalComponent {
  @ViewChild('modal') modal!: NgbModalRef;

  passangers: Passenger[] = [];
  protected readonly dateFormats = dateFormats;

  constructor(private modalService: NgbModal) {}

  show(passangers: Passenger[]) {
    this.passangers = passangers;
    this.modalService.open(this.modal, { size: 'lg' });
  }
}
